import React from "react";
import "materialize-css/dist/js/materialize.min.js";
import ComponentHeader from "../components/ComponentHeader";
import M from "materialize-css/dist/js/materialize.min";
import imss from "../images/experience/imss.png";
import acc from "../images/experience/acc.png";
import ag from "../images/experience/ag.jpg";

const EXPERIENCE_DATA = [
  {
    image: ag,
    websiteLink: "https://www.arisglobal.com/",
    professionTitle: "Senior/Principal Software Engineer",
    descriptionPoints: [
      "Participate in requirement walk through and informing if the story has any impact on existing stories, design discussion, development, code review and technical guidance to juniors.",
      "Developed the successful POC of 0365 and Integrated the O365 with the application to support the document edit using industry standard office word, excel and PowerPoint online.",
      " Developed the rest API’s for the data push and document push through web services.",
      " Integrated the Machine Learning tool (Abby) which will scan the image from the document (OCR)",
      " Analysis of application performance related issue using Dynatrace report, heap dump, thread dump.",
      " Reduced 50% of response time when uploading the documents. ",
      " Resolved High memory usage by the application causing the application shutdown with the help schedulers and pre-defined properties to avoid the high usage of memory.",
      "Integrated the pdf.js along with bookmark support for default pdf viewer for application across all browsers.",
    ],
    date: "Apr 2019 - Sept 2021 | August 2022 - Present | Mysuru, IN",
    tooltip: "Look at the company's website",
  },
  {
    image: acc,
    websiteLink: "https://www.accenture.com/",
    professionTitle: "Application Development Specialist",
    descriptionPoints: [
      "Participate in development, code review and technical guidance to juniors.",
      "Deployment on Non-prod environment using Jenkins.",
      "Deployed the successful POC of installing nginx server as static html viewer in EC2 instance.",
      "Lead team of 6 members including dev , qc & devops members",
      "Developed multiple kafka consumer and producers which followed microservice architecture",
    ],
    date: "Sept 2021 - August 2022 | Bengaluru, IN",
    tooltip: "Look at the company's website",
  },
  {
    image: imss,
    websiteLink: "https://imss.co.in/en/",
    professionTitle: "Software Engineer",
    descriptionPoints: [
      "Developed and maintained Backend REST APIs and services using Spring Framework.",
      "Developed front end with JSP/CSS/HTML/BOOTSTRAP .",
      "Write and execute unit tests and end-to-end (e2e) tests using unit test frameworks likeMockito, JUnit.",
      "Work with team members to design innovative software programs that improve and simplify experience for customers.",
      "Deployed the application on customer servers",
    ],
    date: "Feb 2016 - Mar-2019 | Bengaluru,IN",
    tooltip: "Look at the company's website",
  },
];

class Experience extends React.Component {
  componentDidMount() {
    const elem = document.querySelectorAll(".experience-tooltip");
    M.Tooltip.init(elem, {
      margin: 50,
      enterDelay: 400,
      exitDelay: 200,
    });
  }

  renderHtmlList(descriptionPoints) {
    let count = 0;
    return descriptionPoints.map((point) => {
      ++count;
      return <li key={count}> {point}</li>;
    });
  }

  renderCards() {
    return EXPERIENCE_DATA.map((data) => {
      return (
        <div key={data.professionTitle} className="row justify-content-center">
          <div className="col-12 col-lg-11 col-xl-10">
            <div className="card darken-1">
              <div className="card-content common-attributes">
                <div className="row align-items-center experience-header justify-content-center">
                  <div className="col-10 pb-2 col-sm-4 mr-sm-auto">
                    <a
                      href={data.websiteLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="experience-tooltip"
                      data-position="top"
                      data-tooltip={data.tooltip}
                    >
                      <img
                        src={data.image}
                        className="responsive-img"
                        style={{ height: "auto", maxWidth: "100%" }}
                        alt={data.professionTitle}
                      />
                    </a>
                  </div>
                  <div className="card-title brown-text align-header pr-1 pr-sm-4">
                    {data.professionTitle}
                  </div>
                </div>

                <ul>{this.renderHtmlList(data.descriptionPoints)}</ul>
                <div className="card-action brown-text">
                  <span>{data.date}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  }

  render() {
    return (
      <div>
        <ComponentHeader heading={"Experience"} />
        <div className="container flow-text experience-container">
          {this.renderCards()}
        </div>
      </div>
    );
  }
}

export default Experience;
